// React Dependency
import React from "react";
import { Navigate, useLocation, useRoutes } from "react-router-dom";
// Routes
import { ProtectedRoutes, AuthRoutes } from "./Route";
// Redux & Services & Dto

import { DtoRoutesDefinition } from "../Dto/auth";
import { isAuthenticated } from "../Store/authSlice";
import { useAppSelector } from "../Store/hooks";
import { RoutePermissionCheck } from "./RoutePermission";

const UnAuthRouteMiddleware = () => {
  const location = useLocation();
  return <Navigate to="/sign-in" state={{ locationFrom: location.pathname }} />;
};

const AuthRouteMiddleware = () => {
  const redirectUrl = "/dashboard";
  const location = useLocation();

  return (
    <Navigate to={redirectUrl} state={{ locationFrom: location.pathname }} />
  );
};

const ProtectedRouteMiddleware = (routeDefinition: {
  routeInfo: DtoRoutesDefinition;
}) => {
  const location = useLocation();
  if (RoutePermissionCheck(routeDefinition?.routeInfo)) {
    if (routeDefinition.routeInfo.redirectTo) {
      return (
        <Navigate
          to={routeDefinition.routeInfo.redirectTo}
          state={{ locationFrom: location.pathname }}
        />
      );
    }
    return routeDefinition.routeInfo.element;
  } else {
    return (
      <Navigate to={"/dashboard"} state={{ locationFrom: location.pathname }} />
    );
  }
};

const RoutesComponent = () => {
  const authenticated = useAppSelector(isAuthenticated);
  const ProtectedRoutesMap = ProtectedRoutes.map((routeInfo) => ({
    key: routeInfo.path,
    path: routeInfo.path,
    element: authenticated ? (
      <ProtectedRouteMiddleware routeInfo={routeInfo} />
    ) : (
      <UnAuthRouteMiddleware />
    ),
  }));
  const AuthRoutesMap = AuthRoutes.map((routeInfo) => ({
    key: routeInfo.path,
    path: routeInfo.path,
    element: !authenticated ? routeInfo.element : <AuthRouteMiddleware />,
  }));
  const commonRouteMap = [
    { path: "*", element: <Navigate replace to={"/dashboard"} /> },
  ];
  const errorRouteMap = [{ path: "/error", element: <></>, key: "/error" }];
  const mappedRoutes = [
    ...ProtectedRoutesMap,
    ...AuthRoutesMap,
    ...commonRouteMap,
    ...errorRouteMap,
  ];
  return useRoutes(mappedRoutes);
};

export const AppRoutes = () => {
  return <RoutesComponent />;
};
